import { Phone, Trash2 } from "lucide-react";

interface PhoneNumber {
  id: string;
  phoneNumber: string;
  friendlyName: string;
  status: string;
  dateCreated: string;
}

interface PhoneNumberDisplayProps {
  phoneNumber: PhoneNumber | null;
  isCalling?: boolean;
  isReleasing: boolean;
  /** Omitted when the number has no genie voice to test-call (a Listener Genie's number). */
  onCall?: () => void;
  onRelease: () => void;
  canCall?: boolean;
}

const PhoneNumberDisplay = ({
  phoneNumber,
  isCalling = false,
  isReleasing,
  onCall,
  onRelease,
  canCall = true,
}: PhoneNumberDisplayProps) => {
  if (!phoneNumber) {
    return (
      <div className="flex items-center justify-center gap-2 px-4 py-4 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
        <Phone className="h-5 w-5 flex-shrink-0 text-gray-400" />
        <p className="text-sm text-gray-500">No phone number assigned to this genie</p>
      </div>
    );
  }

  return (
    <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex justify-between items-center">
        <div>
          <p className="font-medium text-gray-900">{phoneNumber.phoneNumber}</p>
          <p className="text-sm text-gray-500">{phoneNumber.friendlyName}</p>
          <p className="text-xs text-gray-400">Status: {phoneNumber.status}</p>
        </div>
        <div className="flex gap-2">
          {onCall && (
            <button
              onClick={onCall}
              disabled={isCalling || !canCall}
              className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors text-sm disabled:opacity-50"
            >
              <Phone className="h-4 w-4 mr-2" />
              {isCalling ? "Calling..." : "Call"}
            </button>
          )}
          <button
            onClick={onRelease}
            disabled={isReleasing}
            className="flex items-center px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors text-sm disabled:opacity-50"
          >
            {isReleasing ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-red-600 mr-2"></div>
                Releasing...
              </>
            ) : (
              <>
                <Trash2 className="h-4 w-4 mr-2" />
                Release
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhoneNumberDisplay;
